import { AsyncPipe, NgIf } from '@angular/common'
import { Component, inject } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { UiDialogService } from '@services'
import { UiDialogComponent } from '../ui-dialog/ui-dialog.component'

@Component({
	selector: 'app-ui-dialog-host',
	standalone: true,
	imports: [AsyncPipe, NgIf, TranslateModule, UiDialogComponent],
	templateUrl: './ui-dialog-host.component.html',
	styleUrl: './ui-dialog-host.component.scss'
})
export class UiDialogHostComponent {
	private uiDialogService = inject(UiDialogService)

	protected dialog$ = this.uiDialogService.dialog$

	protected onAccept() {
		this.uiDialogService.accept()
	}

	protected onReject() {
		this.uiDialogService.reject()
	}

	protected onDismiss() {
		this.uiDialogService.dismiss()
	}
}
